import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  BUTTON_VARIANTS,
  IconClose,
  DialogContent,
  IconButton,
  Loader,
} from 'cdk-radial';
import './ViewLocations.scss';
import { LocationBlock } from '../../../DAABSubscriptions/SelectDMS';
import {
  getDMSDetailsForStore,
  sendSubscribeRequest,
} from '../../../../../../redux/connectedComponent/daabSubscriptions/daabSubscriptions.slice';
import * as _ from 'lodash';

const TITLE = 'Manage DMS';

export const ManageDMS = (props) => {
  const [loading, setLoading] = useState(true);
  const [updatedDMSRequest, setUpdatedDMS] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const { authenticationToken: token } = state?.loginDetailsSlice;
  const {
    fetchingDMSdata,
    dmsByEntity,
    sendingSubscribeRequest,
    subscribeRequestSent,
    errorSendingSubscribeRequest
  } = state.daabSubscriptionsSlice;

  const { handleClose, data, apiDms, apiData, app } = props;

  const { locationId, locationData, subscribeRequest } = data;

  useEffect(() => {
    const noChange = _.isEqual(
      subscribeRequest[locationId].dmsConfig,
      updatedDMSRequest
    );
    const noSelection = !updatedDMSRequest || !updatedDMSRequest.length;
    if (noChange || noSelection) {
      setIsSaveDisabled(true);
    } else {
      setIsSaveDisabled(false);
    }
  }, [updatedDMSRequest]);

  useEffect(() => {
    if (locationData.cmfNumber && locationData.storeId) {
      dispatch(
        getDMSDetailsForStore({
          token,
          cmfNumber: locationData.cmfNumber,
          storeId: locationData.storeId,
          entityId: locationId,
          apiDMS: apiDms,
        })
      );
    }
  }, []);

  useEffect(() => {
    setLoading(fetchingDMSdata);
  }, [fetchingDMSdata]);

  useEffect(() => {
    if (subscribeRequestSent) {
      handleClose();
    }
  }, [subscribeRequestSent, handleClose]);

  useEffect(() => {
    if (errorSendingSubscribeRequest) {
      handleClose();
    }
  }, [errorSendingSubscribeRequest, handleClose]);

  const handleSaveDMS = async () => {
    const payload = {
      appId: app.id,
      appName: app.name,
      entityIdList: [
        {
          entityId: locationId,
          cmfNumber: locationData.cmfNumber,
          dmsConfig: updatedDMSRequest,
        },
      ],
      api: { id: apiData.id, orgId: apiData.orgId, type: apiData.type },
    };
    dispatch(sendSubscribeRequest({ payload, token }));
  };

  const onDMSSelect = (locationId, dmsType, selectedOptions) => {
    const selectedDms = subscribeRequest[locationId]?.dmsConfig || [];
    const selectedByType = _.groupBy(selectedDms, 'dmsType');
    selectedByType[dmsType] = selectedOptions;
    const updatedDmsConfig = _.flatMap(selectedByType);
    setUpdatedDMS(updatedDmsConfig);
  };

  return (
    <>
      <Dialog
        id="manage-dms-dialog"
        isOpen={true}
        onClose={handleClose}
        disableOverlayClicked={true}
        hideHeader
        className="manage-dms-dialog"
        dataTestId="manage-dms-dialog"
        buttonsProps={[
          {
            id: 'manage-dms-cancel-btn',
            onClick: handleClose,
            text: 'Cancel',
            variant: BUTTON_VARIANTS.SECONDARY,
            isDisabled: sendingSubscribeRequest,
          },
          {
            id: 'manage-dms-save-btn',
            isLoading: sendingSubscribeRequest,
            onClick: handleSaveDMS,
            text: 'Save',
            variant: BUTTON_VARIANTS.PRIMARY,
            isDisabled: isSaveDisabled,
            className: 'manage-dms-footer-btn',
          },
        ]}
      >
        <DialogContent>
          <div className="manage-dms-heading">
            <div>{TITLE}</div>
            <IconButton
              className="manage-dms-heading-close-icon"
              icon={<IconClose />}
              onClick={handleClose}
              isDisabled={sendingSubscribeRequest}
            />
          </div>
          <div className="manage-dms-sub-heading-span">
              View or edit DMS accounts for your location.
          </div>
          <div className="manage-dms-dialog-content">
            {loading || _.isEmpty(dmsByEntity) ? (
              <div className="manage-dms-dialog-loader">
                <Loader label="Fetching DMS Config..." />
              </div>
            ) : (
              <LocationBlock
                key={locationId}
                locationId={locationId}
                locationData={locationData}
                entityDMS={dmsByEntity[locationId]}
                onDMSSelect={onDMSSelect}
                subscribeRequest={subscribeRequest}
                apiDMS={apiDms}
                className="manage-dms-box"
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
